var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleanSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.636,
    height: 12.636,
    viewBox: "0 0 12.636 12.636",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-fail",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2197",
    "data-name": "Trazado 2197",
    d: "M6.318,0A6.318,6.318,0,1,1,0,6.318,6.318,6.318,0,0,1,6.318,0Z",
    transform: "translate(0 0)",
    fill: "#969ba0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_8",
    "data-name": "Uni\\xF3n 8",
    d: "M5.2,5.7,2.868,3.352.532,5.7a.191.191,0,0,1-.117.039.141.141,0,0,1-.1-.039l-.26-.26A.122.122,0,0,1,0,5.336a.161.161,0,0,1,.052-.117L2.4,2.869.052.519A.161.161,0,0,1,0,.4.122.122,0,0,1,.052.3l.26-.26A.141.141,0,0,1,.415,0,.191.191,0,0,1,.532.039L2.868,2.386,5.2.039A.191.191,0,0,1,5.321,0a.141.141,0,0,1,.1.039l.26.26a.123.123,0,0,1,.052.1.162.162,0,0,1-.052.117l-2.35,2.35,2.35,2.35a.161.161,0,0,1,.052.117.123.123,0,0,1-.052.1l-.26.26a.141.141,0,0,1-.1.039A.191.191,0,0,1,5.2,5.7Z",
    transform: "translate(3.448 3.449)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanSearch);
export default __webpack_public_path__ + "static/media/clean-search.d6eb3f0a8c5f305c8f9ba15c4079f0af.svg";
export { ForwardRef as ReactComponent };